select {
  --uui-select-border-color: var(--uui-theme-secondary-400);
  --uui-select-background-color: transparent;
  --uui-select-color: var(--uui-theme-secondary-400);
  --uui-select-active-border-color: var(--uui-theme-core-600);
  --uui-select-error-color: var(--uui-theme-error-500);
  --uui-select-hover-border-color: var(--uui-theme-core-400);
  --uui-select-border-radius: var(--uui-border-radius);
  --uui-select-hover-color: var(--uui-theme-core-400);
  --uui-select-padding: 0.625em 2em 0.75em 0.75em;
  --uui-select-font-size: 1em;
  --uui-select-font-weight: var(--uui-font-weight-normal);
  --uui-select-background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' height='16px' width='16px' viewBox='0 0 320 512'><path d='M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z'/></svg>");
  --uui-select-svg-fill: auto;
  --uui-select-filter-brightness: auto;
}

select {
  background-color: var(--uui-select-background-color);
  border-radius: var(--uui-select-border-radius);
  padding: var(--uui-select-padding);
  -webkit-appearance: none;
  border: 1px solid var(--uui-select-border-color); 
  -moz-appearance: none;
  background-image: var(--uui-select-background-image);
  background-position: calc(100% - 0.75em);
  background-repeat: no-repeat;
  height: 2.75rem;
  font-weight: var(--uui-select-font-weight);
  font-size: var(--uui-select-font-size);
  color: var(--uui-select-color);
}

select:not(.error):not(:disabled):hover {
  border-color: var(--uui-select-hover-color);
  box-shadow: 1px 0 var(--uui-select-hover-color),-1px 0 var(--uui-select-hover-color),0 1px var(--uui-select-hover-color),0 -1px var(--uui-select-hover-color);
}

select svg:​path {
  fill: var(--uui-select-svg-fill);
  filter: var(--uui-select-filter-brightness);
}



select:not(.error):not(:disabled):focus,
select:not(.error):not(:disabled):active {
  outline: none;
  border-color: var(--uui-select-active-border-color);
  box-shadow: 1px 0 var(--uui-select-active-border-color),-1px 0 var(--uui-select-active-border-color),0 1px var(--uui-select-active-border-color),0 -1px var(--uui-select-active-border-color);
}

select:disabled {
  opacity: var(--uui-disabled-opacity);
}

select.error:focus {
  outline: none;
}

select.error {
  border-color: var(--uui-select-error-color);
  box-shadow: 1px 0 var(--uui-select-error-color),-1px 0 var(--uui-select-error-color),0 1px var(--uui-select-error-color),0 -1px var(--uui-select-error-color);
}

/** Multi select **/
select[multiple],
select[multiple="true"],
select[multiple],
select[multiple="true"],
select[multiple]:not(.error):not(:disabled):active,
select[multiple]:not(.error):not(:disabled):focus,
select[multiple]:not(.error):not(:disabled):hover {
  background-image: none;
  padding-right: 12px;
}
